export function getVersionName(release: {
  versionNumber: string;
  platform: string | null;
}): string {
  return `${release.platform ? `${release.platform} ` : ''}v${
    release.versionNumber
  }`;
}
